import {StandardEvents} from '@shopify/events';
const resolutionUrl=document.querySelector('topbrush-offers')?.dataset.resolutionUrl;
const {resolveVariant,initialVariant,offerStatus,colorsForVariant,colorPreview,preferredOffer,nativeSelectionInputs}=await import(resolutionUrl);
const swatches={Noir:'#242424',Or:'#B89952',Rose:'#EFAEC0',Rainbow:'linear-gradient(120deg,#DB5970,#EDC44F,#78B196,#688FD5,#A176BA)',Fushia:'#CA3774',Turquoise:'#5AB9BA',Blanc:'#FFFFFF',Corail:'#F08B77',Violet:'#7863A4',Mauve:'#B49AC3',Rouge:'#B84450',Vert:'#668E76',Bleu:'#5B82B2'};
const normalizeTitle=t=>t.replace(/Traitement intense\s*/i,'').replace(/\s*TOPBRUSH™/gi,'').replace(/\s*\|.*$/,'');
class TopbrushOffers extends HTMLElement {
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();
  const data=this.querySelector('[data-offer-data]');
  if(!data)return;
  this.data=JSON.parse(data.textContent);
  this.owner=this.closest('.product-details');
  if(!this.owner)return;
  const selected=initialVariant(this.data.variants,new URL(location.href).searchParams.get('variant'),this.dataset.selectedId);
  if(!selected)return;
  this.offer=selected.options[0];this.colors=selected.options[1]?.split(',')??[];
  this.addEventListener('click',e=>this.onClick(e),{signal:this.abort.signal});
  this.owner.addEventListener(StandardEvents.productSelect,e=>this.onNativeSelect(e),{signal:this.abort.signal});
  customElements.whenDefined('variant-picker').then(()=>{
   if(!this.isConnected)return;
   this.picker=this.owner.querySelector('variant-picker');
   if(!this.picker||typeof this.picker.updateSelectedOption!=='function')return;
   if(this.dataset.ssr!=='true'||String(selected.id)!==this.dataset.selectedId)this.render();
   this.querySelectorAll('.tb-offers button').forEach(button=>button.disabled=false);
   this.dataset.ready='true';
   const preferred=preferredOffer(this.data.variants,this.data.kind,new URL(location.href).searchParams.get('variant'));
   if(preferred&&preferred.options[0]!==this.offer){
    const card=[...this.querySelectorAll('[data-offer]')].find(b=>b.dataset.offer===preferred.options[0]);
    if(card)card.click();
   }
  });
 }
 disconnectedCallback(){this.abort?.abort();}
 onClick(e){
  const card=e.target.closest('[data-offer]');const color=e.target.closest('[data-color]');
  if(!card&&!color)return;
  if(this.closest('quick-add-dialog'))e.stopPropagation();
  if(card){
   this.offer=card.dataset.offer;
   const variants=this.data.variants.filter(v=>v.options[0]===this.offer);
   const count=variants[0].options[1]?.split(',').length??0;
   const choices=[...new Set(variants.flatMap(v=>v.options[1]?.split(',')??[]))];
   this.colors=Array.from({length:count},(_,i)=>choices.includes(this.colors[i])?this.colors[i]:choices[0]);
  }else {this.previewSlot=Number(color.dataset.slot);this.colors[this.previewSlot]=color.dataset.color;}
  this.render();
  const variant=resolveVariant(this.data.variants,this.offer,this.colors);
  const form=this.owner.querySelector('product-form-component');
  if(!variant){form?.querySelectorAll('[type="submit"]').forEach(b=>b.disabled=true);this.status(this.data.labels.unavailable);return;}
  this.picker=this.owner.querySelector('variant-picker');
  const options=nativeSelectionInputs(variant,this.data.variants,[...this.picker.querySelectorAll('input[data-option-name]')]);
  if(!options){this.useFallback();return;}
  options.forEach(r=>this.picker.updateSelectedOption(r));
  const last=options.at(-1);last.dataset.variantId=String(variant.id);
  this.status(this.data.labels.updating);
  this.picker.variantChanged({target:last});
 }
 async onNativeSelect(event){
  if(event.target.tagName!=='VARIANT-PICKER')return;
  const serial=this.serial=(this.serial??0)+1;
  try{
   const result=await event.promise;
   if(serial!==this.serial||!this.isConnected)return;
   const id=result.detail?.resource?.id;
   const selected=this.data.variants.find(v=>String(v.id)===String(id));
   if(selected){this.offer=selected.options[0];this.colors=colorsForVariant(this.data.variants,selected,this.colors);this.previewGallery(result.detail?.html,selected);this.render();}
   else this.status(this.data.labels.unavailable);
  }catch(error){if(error.name==='AbortError')return;this.useFallback();}
 }
 previewGallery(html,variant){
  if(!['topbrush','serviette-pour-cheveux-turbosech'].includes(this.data.kind)||this.colors.length<2||!html)return;
  const image=colorPreview(this.data.variants,variant,this.colors,this.previewSlot??0);
  const gallery=html.querySelector('media-gallery');
  const original=gallery?.querySelector('.product-media img');
  if(!image?.src||!original)return;
  const oldPath=new URL(original.getAttribute('src'),location.origin).pathname;
  for(const img of gallery.querySelectorAll('img')){
   if(new URL(img.getAttribute('src')||'',location.origin).pathname!==oldPath)continue;
   const sized=width=>{const url=new URL(image.src,location.origin);url.searchParams.set('width',width);return url.href;};
   const widths=(img.getAttribute('srcset')||'').match(/\d+(?=w(?:,|$))/g);
   if(widths?.length)img.setAttribute('srcset',widths.map(w=>`${sized(w)} ${w}w`).join(', '));
   else img.removeAttribute('srcset');
   img.setAttribute('src',sized(img.getAttribute('width')||1600));
   if(img.hasAttribute('data_max_resolution'))img.setAttribute('data_max_resolution',sized(3840));
   img.alt=`${this.data.labels.color} : ${this.colors[this.previewSlot??0]??this.colors[0]}`;
  }
 }
 useFallback(){this.dataset.ready='false';const fallback=this.querySelector('[data-offer-fallback]');if(fallback)fallback.open=true;const error=this.querySelector('[data-offer-error]');if(error)error.textContent=this.data.labels.error;}
 status(text){this.querySelector('[data-offer-status]').textContent=text;}
 render(){
  const active=document.activeElement;
  const focus=this.contains(active)?{offer:active.dataset.offer,color:active.dataset.color,slot:active.dataset.slot}:null;
  const offers=[...new Set(this.data.variants.map(v=>v.options[0]))];
  const cards=this.querySelector('[data-offer-cards]');cards.replaceChildren();
  for(const offer of offers){
   const v=this.data.variants.find(v=>v.options[0]===offer);const p=this.data.prices[v.id];
   const card=document.createElement('button');card.type='button';card.className='tb-offers__card';card.dataset.offer=offer;card.setAttribute('aria-pressed',String(offer===this.offer));
   const radio=document.createElement('span');radio.className='tb-offers__radio';radio.setAttribute('aria-hidden','true');
   const title=document.createElement('span');title.className='tb-offers__title';title.textContent=normalizeTitle(offer);
   const keratin=this.data.kind==='traitement-keratine';
   const volumes=offers.map(o=>/2x120ml/i.test(o)?240:/500ml/i.test(o)?500:/120ml/i.test(o)?120:0);
   const ratios=offers.map((o,i)=>volumes[i]?this.data.variants.find(v=>v.options[0]===o).price/volumes[i]:Infinity);
   if(keratin&&/500ml/i.test(offer)&&v.price/500<=Math.min(...ratios)){
    const badge=document.createElement('span');badge.className='tb-offers__badge';badge.textContent=this.data.labels.best;title.append(badge);
   }
   if(this.data.kind==='topbrush'){
    const detail=document.createElement('span');detail.className='tb-offers__detail';detail.textContent=/^2\s/.test(offer)?this.data.labels.duo:this.data.labels.single;title.append(detail);
   }
   const amount=document.createElement('span');amount.className='tb-offers__amount';amount.textContent=p.price;
   if(v.compare_at_price>v.price){const del=document.createElement('del');del.textContent=p.compare;amount.append(del);}
   if(p.unit){const unit=document.createElement('span');unit.className='tb-offers__unit';unit.textContent=p.unit;amount.append(unit);}
   card.append(radio,title,amount);cards.append(card);
  }
  const colorsBox=this.querySelector('[data-offer-colors]');colorsBox.replaceChildren();
  const variants=this.data.variants.filter(v=>v.options[0]===this.offer);
  const choices=[...new Set(variants.flatMap(v=>v.options[1]?.split(',')??[]))];
  this.colors.forEach((selected,slot)=>{
   const fieldset=document.createElement('fieldset');fieldset.className='tb-offers__swatches';
   const legend=document.createElement('legend');legend.textContent=`${this.data.labels.color}${this.colors.length>1?' '+(slot+1):''} : ${selected}`;
   const row=document.createElement('div');row.className='tb-offers__swatch-row';
   for(const c of choices){const b=document.createElement('button');b.type='button';b.className='tb-offers__swatch';b.dataset.color=c;b.dataset.slot=String(slot);b.title=c;b.setAttribute('aria-label',`${this.data.labels.color} ${slot+1} : ${c}`);b.setAttribute('aria-pressed',String(c===selected));b.style.setProperty('--swatch',swatches[c]??'#B9ABA2');b.append(document.createElement('span'));row.append(b);}
   fieldset.append(legend,row);colorsBox.append(fieldset);
  });
  const v=resolveVariant(this.data.variants,this.offer,this.colors);
  this.status(offerStatus(v,this.data));
  if(focus){
   const target=focus.offer?[...this.querySelectorAll('[data-offer]')].find(b=>b.dataset.offer===focus.offer):[...this.querySelectorAll('[data-color]')].find(b=>b.dataset.color===focus.color&&b.dataset.slot===focus.slot);
   target?.focus({preventScroll:true});
  }
 }
}
if(!customElements.get('topbrush-offers'))customElements.define('topbrush-offers',TopbrushOffers);


